if (!customElements.get('bundle-product-summary')) {
  class BundleProductSummary extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.updateOptionLabels());
    }

    updateOptionLabels() {
      const productInfo = this.closest('.product__info-container');
      if (!productInfo) return;

      const labelMap = {
        'duuduu-duo-bundle': ['Mattress 1 size', 'Mattress 2 size'],
        'move-in-bundle': ['Mattress size', 'Sheet colour'],
        'sweet-slumber-bundle': ['Mattress size'],
      };
      const labels = labelMap[this.dataset.bundleHandle] || [];

      productInfo
        .querySelectorAll('variant-selects .product-form__input--dropdown > .form__label')
        .forEach((label, index) => {
          if (labels[index]) label.textContent = labels[index];
        });
    }
  }

  customElements.define('bundle-product-summary', BundleProductSummary);
}
